import { cn } from '@/lib/utils';

interface ProgressDotsProps {
  count: number;
  max?: number;
  className?: string;
}

export function ProgressDots({ count, max = 4, className }: ProgressDotsProps) {
  return (
    <div className={cn('flex gap-1', className)}>
      {Array.from({ length: max }).map((_, i) => (
        <div
          key={i}
          className={cn(
            'h-1.5 w-1.5 rounded-full calm-transition',
            i < count ? 'bg-primary' : 'bg-border'
          )}
        />
      ))}
    </div>
  );
}
